/**
 * @generated SignedSource<<24689a76666b93de5fba310033070295>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewIssueItemSectionTitle_issue$data = {
  readonly taskExecution: {
    readonly sectionVersion: {
      readonly title: string | null;
    };
  };
  readonly " $fragmentType": "WidgetIssueOverviewIssueItemSectionTitle_issue";
};
export type WidgetIssueOverviewIssueItemSectionTitle_issue$key = {
  readonly " $data"?: WidgetIssueOverviewIssueItemSectionTitle_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItemSectionTitle_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueOverviewIssueItemSectionTitle_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "taskExecution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSectionVersion",
          "kind": "LinkedField",
          "name": "sectionVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "73fdc1a0e4f34156ba40efde7deb50ee";

export default node;
